import DOMPurify from "dompurify";

// Очистка HTML из API (правила тарифа, инфо-страницы) перед dangerouslySetInnerHTML — защита от XSS.
// Разрешённые теги/атрибуты по умолчанию (таблицы, ссылки, списки, style) сохраняются.
export const sanitizeHtml = (html) => {
  if (html === null || html === undefined) return "";
  return DOMPurify.sanitize(String(html), {
    USE_PROFILES: { html: true },
    ADD_ATTR: ["target"],
  });
};
